import React from "react";

import { SEO } from "../components/common/seo";
import { HomePage } from "../components/Pages/Home";

const IndexPage: React.FC = () => {
  return (
    <>
      <SEO title="Home" />

      <HomePage />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default IndexPage;

// export const query = graphql`
//   query HomeQuery {
//   }
// `;
